<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            <div class="modal-container" @click.stop>

              <div class="modal-header row" style="justify-content: flex-end;">
                <!-- <div class="col-6">
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                </div> -->
                <div class="col">
                  <button type="button" class="close" @click="$emit('closeModal')">
                      <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

              <div class="modal-body">
                <h2 class="title">Tambah Step</h2>
                <form>
                  <div class="row row-space">
                    <div class="col-md-6">
                      <div class="input-group">
                        <label class="label">Step Pekerjaan<span style="color: red;">*</span></label>
                        <MultiSelect
                          v-model="selected.woStep"
                          :options="options.woSteps"
                          :searchable="true"
                          :close-on-select="true"
                          :multiple="false"
                          :allow-empty="false"
                          track-by="id"
                          label="name"
                          placeholder="Pilih Step Pekerjaan"
                        ></MultiSelect>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="input-group">
                        <label class="label">Nama Pekerja<span style="color: red;">*</span></label>
                        <MultiSelect
                          v-model="selected.laborer"
                          :options="filtered.laborer"
                          :searchable="true"
                          :max-height="200"
                          :close-on-select="true"
                          :multiple="false"
                          :allow-empty="false"
                          track-by="id"
                          label="name"
                          placeholder="Pilih Nama Pekerja"
                          tag-position="bottom"
                          :disabled="!selected.woStep"
                        ></MultiSelect>
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-md-12">
                      <div class="input-group">
                        <label class="label">Jasa Estimasi</label>
                        <!-- {{options.estimations}} -->
                        <MultiSelect
                          v-model="form.estimations"
                          :options="options.estimations.map(x => x.id)"
                          :close-on-select="false"
                          :custom-label="opt => options.estimations.find(x => x.id == opt).sparepart_name"
                          :multiple="true"
                          placeholder="Pilih Jasa Estimasi"
                          tag-position="bottom"
                        ></MultiSelect>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col mt-5" style="text-align: center">
                      <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
                      <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()" :disabled="selected.woStep == null || selected.laborer == null">Tambah</button>
                    </div>
                  </div>
                </form>
              </div>
          </div>
        </div>
      </div>
      <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
    </div>
  </div>
</transition>
</template>

<script>
  import MultiSelect from 'vue-multiselect';

  export default {
    data () {
      return {
        options : {
          woSteps : this.$store.getters.getWoSteps,
          laborer : [],
          laborerType : this.$store.getters.getLaborerType,
          estimations : [],
        },
        selected : {
          woStep : null,
          laborer : null,
        },
        form : {
          work_order_code : this.form_code,
          step_id : '',
          labourer_id : '',
          estimations : [],
        },
        filtered : {
          laborer: []
        },
        submitting : false
      }
    },
    props : ['form_code', 'estimationData'],
    components:{
      MultiSelect,
    },
    mounted () {
      this.fetchLaborer();

      this.options.estimations = this.estimationData.filter(x=>x.sparepart_type=='J' && x.type != 'G/C');
      this.form.estimations = this.options.estimations.map(x => x.id)
    },
    watch : {
      'selected.woStep'(){
        this.form.step_id = this.selected.woStep ? this.selected.woStep.id : '';
        let listOfLaborers = [];
        for (var i = 0; i < this.options.laborer.length; i++) {
          //If labourer has the type of the selected step job
          if (this.options.laborer[i].labour_type.map(x=>x.labourer_type_id).indexOf(this.selected.woStep.labourer_type.id) !== -1)
            listOfLaborers.push(this.options.laborer[i])
        }
        this.filtered.laborer = listOfLaborers;
      },
      'selected.laborer'(){
        this.form.labourer_id = this.selected.laborer ? this.selected.laborer.id : '';
      }
    },
    methods : {
      validateForm(){
        var valid = true;
        var error = [];

        if(this.form.step_id == '' || this.form.step_id == null){//Step Pekerjaan [Required]
          valid = false;
          error.push('Step pekerjaan wajib diisi');
        }

        if(this.form.labourer_id == '' || this.form.labourer_id == null){//Pekerja [Required]
          valid = false;
          error.push('Pekerja wajib diisi');
        }
        console.log(this.selected.laborer , this.selected.woStep)

        var compiledLabourTypes = this.selected.laborer.labour_type.map((x)=>{return {id:x.labourer_type_id, name:x.labourer.name}})
        if (!compiledLabourTypes.find(x=>x.id == this.selected.woStep.labourer_type.id)) {
          valid = false;
          error.push(`Pekerja '${this.selected.laborer.name}' tidak memiliki tipe pekerjaan '${this.selected.woStep.labourer_type.name}' untuk menjalani step pekerjaan '${this.selected.woStep.name}'.`)
        }

        if(!valid){
          this.$store.dispatch('triggerAlert', [false, error]);
          this.submitting = false
        } 
        else return valid;
      },
      async submitForm(){
        let vm = this;
        if(this.submitting) {
          this.$store.dispatch('triggerAlert' , [false , 'Penginputtan Step Bengkel Sedang Berlanjut. Mohon Ditunggu.'])
          return
        }
        this.submitting = true
        if(vm.validateForm()){

          //If epoxy
          if (this.form.step_id == 6) {
            for (var i in this.form.estimations) {
              let data = {data : JSON.parse(JSON.stringify(this.form))}
              data.data.estimations = [this.form.estimations[i]]

              let response = await this.callApi('/api/v1/workorder/steps', data)
              console.log(response);
            }
          } else {//Other than epoxy
           let response = await this.callApi('/api/v1/workorder/steps', {data:this.form})
           console.log(response);
          }

          this.$emit('updateTable');
          this.$emit('closeModal');
        }
      },
      async callApi (url, data) {
        let message = ''

        await this.$http.post(url, data)
        .then((resp)=>{
          this.$store.dispatch('triggerAlert', [true, [`Step pekerjaan ${this.selected.woStep.name} telah berhasil dimulai oleh ${this.selected.laborer.name}`]])
          this.submitting = false
          message += 'Successfully'
        })
        .catch((err)=>{
          console.log(err);
          this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
          this.submitting = false
          message += 'Unsuccessfully'
        })

        return `API has been run ${message}`
      },
      fetchLaborer () {
        this.$http.get(`/api/v1/masterData/labourer?pagination=false`)
        .then((resp)=>{
          this.options.laborer = resp.data.data
        })
        .catch((err)=>{console.log(err)})
      },
    }
  }
</script>

<style scoped>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}
</style>
